module.exports = "<p>\n  test works!\n</p>\n"